import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '@/components/atoms/Alert';
import { Button } from '@/components/atoms/Buttons';

export interface ImpersonationBannerProps {
    message?: string;
    buttonText?: string;
    impersonatorName?: string;
    impersonatedName?: string;
    onSwitchBack: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => Promise<void> | void;
}

export default function ImpersonationBanner(props: ImpersonationBannerProps) {
    const {
        message,
        buttonText,
        impersonatorName = '',
        impersonatedName = '',
        onSwitchBack,
    } = props;
    const { t } = useTranslation('impersonation');

    const displayMessage =
        message ||
        t('banner.actingAsMessage', {
            impersonator: impersonatorName,
            impersonated: impersonatedName,
        });

    const displayButtonText = buttonText || t('banner.switchBack');

    return (
        <Alert
            tone="neutral"
            layout="banner"
            size="small"
            align="center"
            action={
                <Button
                    size="small"
                    trackingId="impersonation_switch_back"
                    onClick={async (e) => await onSwitchBack(e)}>
                    {displayButtonText}
                </Button>
            }>
            <span>{displayMessage}</span>
        </Alert>
    );
}
